import React, { useEffect, useMemo, useRef } from 'react';
import BackgroundMaterial from './materials/BackgroundMaterial';
import { Color, Mesh, ShaderMaterial, SphereBufferGeometry } from 'three';
import { useFrame, useThree } from '@react-three/fiber';
import { Colors } from '../../data/Colors';
import { useDetailViewContext } from '../../context/DetailViewContext';
import FocusPoints from '../../data/FocusPoints';
import gsap from 'gsap';

const white = new Color(Colors.White);
const black = new Color(Colors.FraunhoferBlack);
const lightGrey = new Color(Colors.NeutralGrey);
const darkGrey = new Color(Colors.DarkModeGrey);

export default function BackgroundSphere(): JSX.Element
{
  const ref = useRef<Mesh>();
  const { camera } = useThree();

  useFrame(() => {
    const mesh = ref.current;
    if (mesh) {
      mesh.position.copy(camera.position);
      mesh.position.z -= 5;
      mesh.rotation.x = -0.3;
    }
  });

  const materialRef = useRef<ShaderMaterial>(null);
  const { activeFocusID } = useDetailViewContext();
  useEffect(() => {
    const mat = materialRef.current;
    if (!mat) return;
    const bgColor = mat.uniforms.bgColor.value;
    const lineColor = mat.uniforms.lineColor.value;
    let targetColor = activeFocusID === FocusPoints.None? white : black;
    gsap.to(bgColor, {
      r: targetColor.r,
      g: targetColor.g,
      b: targetColor.b
    });

    targetColor = activeFocusID === FocusPoints.None? lightGrey : darkGrey;
    gsap.to(lineColor, {
      r: targetColor.r,
      g: targetColor.g,
      b: targetColor.b
    });
  }, [activeFocusID]);

  const geometry = useMemo(() => new SphereBufferGeometry(10, 64, 48), []);
  return <mesh geometry={geometry} ref={ref}>
    <BackgroundMaterial bgColor={Colors.White} lineColor={Colors.LighterGrey} ref={materialRef} />
  </mesh>;
}